var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "448.743px",
    height: "285.708px",
    viewBox: "0 0 448.743 285.708",
    enableBackground: "new 0 0 448.743 285.708",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#EBEBEB",
    d: "M-0.223,120.663c-8.525,67.104,25.888,135.891,80.27,176.118 s125.939,53.465,192.899,43.873c47.799-6.848,95.212-25.59,128.902-60.182c33.689-34.591,51.452-86.561,37.876-132.9 c-5.128-17.502-15.198-34.458-31.181-43.246c-25.52-14.03-57.02-3.741-84.176,6.777c-27.155,10.519-58.607,20.881-84.188,6.962 c-19.655-10.695-29.747-32.698-44.152-49.821c-24.494-29.115-64.281-44.568-102.006-39.618c-4.715,0.619-9.38,1.554-13.964,2.784 C39.926,42.18,9.585,75.151,0.831,115.771L-0.223,120.663z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.252,
    y: 56.434,
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -58.1646 74.2462)",
    fill: "#F5F5F5",
    width: 103.879,
    height: 152.958
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0E0E0",
    points: "134.276,161.578 133.296,167.643 90.373,161.458 91.354,155.395  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0E0E0",
    points: "112.659,139.943 118.818,140.831 111.99,183.093 105.831,182.205  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M100.453,88.731"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -46.1062 46.5967)",
    fill: "#E0E0E0",
    cx: 53.687,
    cy: 99.23,
    rx: 23.383,
    ry: 0.201
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M104.877,78.259c0.062,0.092-14.327,9.824-32.135,21.735c-17.813,11.915-32.299,21.496-32.361,21.404 c-0.062-0.092,14.325-9.822,32.139-21.737C90.327,87.75,104.815,78.167,104.877,78.259z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M111.242,87.775c0.062,0.092-14.327,9.824-32.135,21.734c-17.813,11.915-32.3,21.496-32.361,21.404 c-0.062-0.092,14.325-9.823,32.139-21.737C96.691,97.267,111.181,87.684,111.242,87.775z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M117.607,97.292c0.062,0.092-14.327,9.824-32.135,21.735c-17.814,11.915-32.3,21.495-32.361,21.403 s14.324-9.822,32.139-21.737C103.057,106.783,117.546,97.2,117.607,97.292z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M123.973,106.808c0.062,0.092-14.328,9.825-32.136,21.735c-17.813,11.915-32.299,21.497-32.36,21.404 c-0.062-0.092,14.324-9.822,32.138-21.737C109.422,116.299,123.911,106.716,123.973,106.808z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 325.656,
    y: 139.086,
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -50.7043 239.6183)",
    fill: "#F5F5F5",
    width: 87.241,
    height: 128.458
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0E0E0",
    points: "403.78,227.389 402.957,232.481 366.91,227.288 367.732,222.194  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0E0E0",
    points: "385.627,209.22 390.799,209.964 385.063,245.457 379.892,244.711  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M375.375,166.209"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -40.5771 216.4041)",
    fill: "#E0E0E0",
    cx: 336.099,
    cy: 175.027,
    rx: 19.639,
    ry: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -38.1708 225.3338)",
    fill: "#E0E0E0",
    cx: 352.007,
    cy: 175.529,
    rx: 32.582,
    ry: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M384.437,165.406c0.062,0.092-12.016,8.277-26.971,18.28c-14.96,10.007-27.134,18.041-27.195,17.949 s12.012-8.275,26.973-18.282C372.198,173.351,384.375,165.314,384.437,165.406z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M389.781,173.398c0.062,0.092-12.015,8.277-26.97,18.28c-14.96,10.006-27.134,18.04-27.195,17.949 c-0.062-0.092,12.012-8.275,26.973-18.282C377.544,181.343,389.72,173.307,389.781,173.398z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M395.127,181.391c0.062,0.092-12.015,8.277-26.97,18.28c-14.961,10.006-27.134,18.04-27.195,17.949 c-0.062-0.093,12.012-8.276,26.973-18.283C382.889,189.335,395.065,181.299,395.127,181.391z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.268,
    y: 16.161,
    transform: "matrix(0.8818 0.4716 -0.4716 0.8818 62.0751 -83.2508)",
    fill: "#F5F5F5",
    width: 89.727,
    height: 132.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0E0E0",
    points: "191.993,125.186 186.974,126.905 174.231,91.68 179.251,89.961  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E0E0E0",
    points: "199.689,99.916 201.518,104.97 166.535,116.951 164.707,111.896  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M233.753,69.788"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8818 0.4716 -0.4716 0.8818 42.5529 -92.957)",
    fill: "#E0E0E0",
    cx: 206.735,
    cy: 38.419,
    rx: 20.198,
    ry: 0.238
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M243.532,68.901c-0.062,0.116-13.344-6.866-29.661-15.593c-16.323-8.73-29.501-15.899-29.439-16.015 c0.063-0.116,13.341,6.865,29.664,15.595C230.413,61.615,243.595,68.785,243.532,68.901z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M238.868,77.621c-0.062,0.116-13.343-6.866-29.66-15.593c-16.324-8.73-29.502-15.898-29.439-16.015 c0.062-0.116,13.34,6.865,29.663,15.595C225.749,70.335,238.931,77.506,238.868,77.621z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M234.204,86.342c-0.062,0.116-13.343-6.867-29.66-15.594c-16.323-8.729-29.501-15.898-29.439-16.014 c0.063-0.116,13.341,6.865,29.664,15.595C221.086,79.056,234.267,86.226,234.204,86.342z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M229.541,95.062c-0.062,0.116-13.343-6.866-29.661-15.593c-16.323-8.73-29.501-15.899-29.439-16.015 c0.063-0.116,13.341,6.866,29.664,15.595C216.422,87.776,229.603,94.946,229.541,95.062z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7AB33",
    d: "M154.699,126.86L127.487,266.76l-3.563,18.314l181.658-0.896c8.152-0.04,15.377-7.278,18-18.033 l32.212-132.08c1.991-8.164-2.378-16.656-8.566-16.649l-183.858,0.193C159.311,117.612,155.761,121.4,154.699,126.86z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.699,126.861L127.487,266.76l-3.563,18.314l181.658-0.896c8.152-0.04,15.377-7.278,18-18.033l32.212-132.08 c1.991-8.164-2.378-16.656-8.566-16.649l-183.858,0.194C159.311,117.613,155.761,121.4,154.699,126.861z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7AB33",
    d: "M288.157,257.281l-19.233-154.989c-0.788-6.351-5.847-11.087-11.82-11.068l-42.175,0.138 c-3.121,0.01-6.114,1.337-8.331,3.694l-20.026,21.289l-117.297,0.612c-7.168,0.038-12.675,6.82-11.725,14.44l17.857,143.25 c0.791,6.342,5.84,11.072,11.805,11.062l204.422-0.404c22.769,0.472,24.941-6.253,24.941-6.253 C290.483,284.834,288.159,257.299,288.157,257.281z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "200.012,226.263 193.117,233.667 140.018,185.898 146.912,178.494  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "190.228,176.852 197.848,183.707 149.802,235.309 142.182,228.454  "
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.04f9d633aa7133324a22e4d656746bc2.svg";
export { ForwardRef as ReactComponent };